import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { BooleanActionDetail } from "./components/BooleanActionDetail";
import { PercentageSliderActionDetail } from "./components/PercentageSliderActionDetail";
import { FloatInputField } from "../../shared/FloatInputField";
import { ElementGroup, ElementLabel } from "./components/BaseElements";
export const ShakeCameraActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();

  function onIntensitySliderChange(sliderValue) {
    action.setIntensity(sliderValue);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PercentageSliderActionDetail, {
    keyName:
    /*t*/
    "action_editor.node_shake_camera_intensity",
    keyLabelLeft:
    /*t*/
    "action_editor.node_shake_camera_intensity_low",
    keyLabelRight:
    /*t*/
    "action_editor.node_shake_camera_intensity_high",
    min: 0.0,
    max: 1,
    step: 0.01,
    value: action.intensity,
    valueSetter: onIntensitySliderChange
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.node_shake_camera_fade_out"),
    checked: action.fadeOut,
    toggle: () => action.setFadeOut(!action.fadeOut)
  }), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.node_shake_camera_duration")), /*#__PURE__*/React.createElement(FloatInputField, {
    value: action.durationSeconds,
    onlyPositive: true,
    onChange: value => action.setDurationSeconds(value)
  })));
});